import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/info",
)({
  staticData: { title: "Aircraft Info" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/info/info.tsx"),
    "Info",
  ),
})
